import React from 'react';
import { Redirect, RouteComponentProps } from 'react-router';

type StoryRedirectProps = RouteComponentProps<{ id: string }>

export function StoryRedirect({ match } : StoryRedirectProps) {
  const to = `/stories/${match.params.id}/branches`;
  return (<Redirect to={to} />);
}
